export enum AppRoutes {
    GUARANTEE_ORDERS = 'guarantee-orders',
    STYLE_GUIDE = 'style-guide',
    LOGGED_OUT = 'logged-out',
    UNAUTHORIZED = 'unauthorized',
    ERROR = 'error'
}

export enum Role {
    BROWSING = 'BROWSING',
    ENTERING = 'ENTERING',
    SIGNING = 'SIGNING'
}

export enum ApiUrls {
    authenticate = 'clientAuthenticate',
    guaranteeOrders = 'guaranteeOrders',
    dictionaries = 'dictionaries',
    clients = 'clients',
    representatives = 'representatives',
    formTemplates = 'formTemplates',
    formTemplateVersions = 'formTemplateVersions',
    guaranteeOrderAttachment = 'guaranteeOrderAttachment'
}

export enum HttpStatus {
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    ACCESS_DENIED = 403,
    NOT_FOUND = 404,
    NOT_ACCEPTABLE = 406,
    CONTENT_TOO_LARGE = 413,
    INTERNAL_SERVER_ERROR = 500
}

export enum PrintTemplateLanguage {
    POL = 'POL',
    ENG = 'ENG',
    ALL = 'ALL'
}

export enum PrintTemplateType {
    ORDER_TEMPLATE = 'ORDER_TEMPLATE',
    TEMPLATE = 'TEMPLATE'
}

export enum AppLanguages {
    PL = 'PL',
    EN = 'EN'
}

export enum DownloadListFileExtension {
    CSV = 'CSV',
    XLSX = 'XLSX'
}

export enum ErrorRoutes {
    NOT_FOUND = 404
}
